export default "__VITE_PUBLIC_ASSET__cb1d1127__"